var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Name=User Admin, Shape=-"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.857 2.32549C283.721 -5.13037 328.528 5.36772 356.407 33.4515C383.326 60.5678 375.479 104.585 383.466 141.95C390.385 174.319 403.906 204.528 400.003 237.397C395.383 276.307 391.192 321.737 359.4 344.641C327.619 367.536 284.025 348.799 244.857 349.169C205.172 349.544 158.843 372.673 128.733 346.819C98.353 320.733 116.529 270.596 107.829 231.51C100.318 197.761 70.533 166.699 81.3325 133.854C92.1285 101.02 133.668 92.6795 160.6 71.0167C189.545 47.7356 208.377 9.32415 244.857 2.32549Z",
    fill: "url(#paint0_linear_2258_99300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.448 0.689667C264.211 6.20094 275.652 44.9705 300.493 63.9407C321.31 79.8381 348.296 84.7316 367.216 102.846C390.387 125.03 428.906 148.809 421.818 180.099C414.015 214.547 354.663 209.329 336.266 239.478C318.621 268.393 347.704 313.591 325.012 338.738C303.942 362.09 262.71 364.948 233.448 353.427C203.991 341.828 198.441 302.111 175.794 279.986C160.149 264.702 138.202 259.124 121.944 244.494C100.242 224.965 73.7305 207.897 64.7947 180.099C55.0435 149.764 54.6619 113.636 71.1073 86.3451C87.5223 59.1051 122.814 51.9867 150.938 37.1475C177.993 22.8725 203.339 -4.70447 233.448 0.689667Z",
    fill: "url(#paint1_linear_2258_99300)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/outlined/user/user-star-line",
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M240.35 193.333V206.667C229.96 206.667 219.996 210.881 212.649 218.382C205.303 225.884 201.175 236.058 201.175 246.667H188.117C188.117 232.522 193.62 218.956 203.416 208.954C213.211 198.952 226.497 193.333 240.35 193.333ZM240.35 186.667C218.706 186.667 201.175 168.767 201.175 146.667C201.175 124.567 218.706 106.667 240.35 106.667C261.994 106.667 279.525 124.567 279.525 146.667C279.525 168.767 261.994 186.667 240.35 186.667ZM240.35 173.333C254.78 173.333 266.467 161.4 266.467 146.667C266.467 131.933 254.78 120 240.35 120C225.921 120 214.234 131.933 214.234 146.667C214.234 161.4 225.921 173.333 240.35 173.333ZM279.525 243.333L260.336 253.633L263.999 231.82L248.479 216.367L269.934 213.18L279.525 193.333L289.123 213.18L310.571 216.367L295.051 231.82L298.708 253.633L279.525 243.333Z",
    fill: "#41435B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2258_99300",
    x1: 79,
    y1: 179.522,
    x2: 400.697,
    y2: 179.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F95C5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2258_99300",
    x1: 58,
    y1: 180,
    x2: 422.675,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15F0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E95FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminInvitation);
export default __webpack_public_path__ + "static/media/adminInvitation.33146b8be4af25d01a7f88a4f72db0a1.svg";
export { ForwardRef as ReactComponent };